import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ContactCardActionItemProps {
  iconName: IconName;
  onOpenContactDetails: () => void;
  onTrackEvent: () => void;
}

/*
 * Style.
 */

const StyledActionItemWrapperDiv = styled.div`
  display: grid;
  grid-template-columns: 16px auto;
  grid-gap: 8px;
  margin: 0 -16px;
  padding: 8px 16px;

  &:hover {
    background: ${(p) => p.theme.alphas.gray10};
  }
  /* If we are the last item, we need to remove some spacing from the bottom */
  &:last-child {
    margin-bottom: -8px;
  }
`;

/*
 * Component.
 */

export const ContactCardActionItem: FC<PropsWithChildren<ContactCardActionItemProps>> = (props) => {
  const theme = useUserTheme();
  const {iconName, children, onOpenContactDetails, onTrackEvent} = props;

  const onClickHandler = () => {
    onTrackEvent();
    onOpenContactDetails();
  };

  return (
    <StyledActionItemWrapperDiv onClick={onClickHandler}>
      <Icon name={iconName} color={theme.greys.shade70} />
      <div>{children}</div>
    </StyledActionItemWrapperDiv>
  );
};
